import { __rest } from "tslib";
import React from 'react';
import { matchPath } from 'react-router-dom';
export default function BallparkRoute(_a) {
    var { exact, path, route: Route } = _a, props = __rest(_a, ["exact", "path", "route"]);
    const isMatchingPath = matchPath(window.location.pathname, { exact, path });
    if (!isMatchingPath) {
        return null;
    }
    return React.createElement(Route, Object.assign({ exact: exact, path: path }, props));
}
